"use strict";
var ErrorObservable_1 = require('./ErrorObservable');
exports._throw = ErrorObservable_1.ErrorObservable.create;
//# sourceMappingURL=throw.js.map


//////////////////
// WEBPACK FOOTER
// ./~/rxjs/observable/throw.js
// module id = 469
// module chunks = 0